import moment from "moment/moment";
import { parseStrapiImage } from "utils";
import { isVideoMedia } from "utils/supportVideos";

export const resolveLocalizedTitle = (item, locale) => {
    const rawTranslations = item?.title_translations?.data || item?.title_translations
    const translations = Array.isArray(rawTranslations)
        ? rawTranslations
        : (rawTranslations ? [rawTranslations] : [])
    const match = translations.find(translation => (
        (translation?.attributes?.locale || translation?.locale) === locale
        && `${translation?.attributes?.title || translation?.title || ''}`.trim()
    ))

    return match?.attributes?.title || match?.title || item?.attributes?.title || item?.title
}

const withLocalizedCategory = (category, locale, type) => ({
    ...category,
    sourceTitle: category?.attributes?.title || category?.title,
    title: resolveLocalizedTitle(category, locale),
    type,
})

const getRawCategories = item => Array.isArray(item?.categories?.data)
    ? item.categories.data.map(c => c)
    : (Array.isArray(item?.categories) ? item.categories.map(c => c) : (item?.categories ? (item.categories?.data ? [item.categories] : [item.categories]) : []))

const getLocalizedSubCategories = (item, locale) => (
    Array.isArray(item?.sub_categories) ? item.sub_categories : []
).map(subCategory => ({
    ...subCategory,
    title: resolveLocalizedTitle(subCategory, locale),
}))

const normalizePreviewVideo = (value) => {
    if (value && typeof value === "object" && value?.value) {
        return value;
    }

    const normalizedValue = `${value || ""}`.trim();

    if (!normalizedValue) return null;

    return {
        sourceType: /^https?:\/\//i.test(normalizedValue) ? "url" : "wistia",
        value: normalizedValue,
    };
};

export const adapterIfus = m => {

    const pdfUrl = (m?.document)
    return {
        ...m,
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || [],
        tags: m?.tags?.data?.map(t => t?.attributes?.name) || [],
        document: parseStrapiImage(pdfUrl.url),
        type: 'ifus',
        title: pdfUrl?.name
    }
}
export const adapterCourses = (m, locale) => {

    const image = m?.image
    const category = m?.category

    const rawCategories = Array.isArray(m?.categories?.data)
        ? m.categories.data.map(c => c)
        : (Array.isArray(m?.categories) ? m.categories.map(c => c) : (m?.categories ? (m.categories?.data ? [m.categories] : [m.categories]) : []))
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,

        title: resolveLocalizedTitle(m, locale),
        description: m?.description,
        cover: parseStrapiImage(image?.url),
        imageUrl: parseStrapiImage(image?.url),
        previewVideo: normalizePreviewVideo(m?.previewVideo || m?.video_preview),
        raw_category: rawCategories.map(c => withLocalizedCategory(c, locale, 'courses')),
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        type: 'courses',
        uid: 'api::course.course',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterPartnersAndStaff = (m, locale) => {

    const image = m?.image
    const category = m?.category

    const rawCategories = Array.isArray(m?.categories?.data)
        ? m.categories.data.map(c => c)
        : (Array.isArray(m?.categories) ? m.categories.map(c => c) : (m?.categories ? (m.categories?.data ? [m.categories] : [m.categories]) : []))
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        raw_category: rawCategories.map(c => withLocalizedCategory(c, locale, 'partners-and-staffs')),
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        type: 'partners-and-staffs',
        uid: 'api::partners-and-staff.partners-and-staff',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterArticles = (m, locale) => {

    const image = (m?.image)
    const category = (m?.category)

    return {
        ...m,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        raw_category: { ...category, type: 'articles' },
        category: category?.title,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'articles',
        uid: 'api::article.article',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterPodcasts = (m, locale) => {

    const image = (m?.image)
    const video = (m?.video)
    const category = (m?.category)

    return {
        ...m,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        video: parseStrapiImage(video?.url),
        raw_category: { ...category, type: 'podcasts' },
        category: category?.title,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'podcasts',
        uid: 'api::podcast.podcast',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterDocuments = (m, locale) => {

    const image = m?.image
    const document = m?.document
    const category = m?.category
    const rawCategories = getRawCategories(m)
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        document: parseStrapiImage(document?.url),
        raw_category: rawCategories.length ? rawCategories.map(c => withLocalizedCategory(c, locale, 'documents')) : { ...category, type: 'documents' },
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'documents',
        uid: 'api::document.document',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterProductInformations = (m, locale) => {

    // const image = (m?.image)
    // const document = (m?.document)

    const image = (m?.image)
    const document = (m?.document)
    const category = (m?.category)

    const rawCategories = Array.isArray(m?.categories?.data)
        ? m.categories.data.map(c => (c))
        : (Array.isArray(m?.categories) ? m.categories.map(c => (c)) : (m?.categories ? (m.categories?.data ? [(m.categories)] : [(m.categories)]) : []))
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        document: parseStrapiImage(document?.url),
        raw_category: rawCategories.map(c => withLocalizedCategory(c, locale, 'product-informations')),
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'product-informations',
        uid: 'api::product-information.product-information',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || [],
        document_type: m?.type?.data?.attributes?.document_type
    }
}
export const adapterSupportMaterial = (m, locale) => {

    const image = (m?.image)
    const document = (m?.document)
    const category = (m?.category)
    const documentUrl = typeof document === 'string' ? document : document?.url



    const rawCategories = Array.isArray(m?.categories?.data)
        ? m.categories.data.map(c => (c))
        : (Array.isArray(m?.categories) ? m.categories.map(c => (c)) : (m?.categories ? (m.categories?.data ? [(m.categories)] : [(m.categories)]) : []))
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        document: parseStrapiImage(documentUrl),
        raw_category: rawCategories.map(c => withLocalizedCategory(c, locale, 'support-materials')),
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'support-materials',
        uid: 'api::support-material.support-material',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterMarketingMaterial = (m, locale, type = 'marketing-materials', uid = 'api::marketing-material.marketing-material') => {

    const image = (m?.image)
    const document = (m?.document)
    const category = (m?.category)
    const documentUrl = typeof document === 'string' ? document : document?.url

    const rawCategories = Array.isArray(m?.categories?.data)
        ? m.categories.data.map(c => (c))
        : (Array.isArray(m?.categories) ? m.categories.map(c => (c)) : (m?.categories ? (m.categories?.data ? [(m.categories)] : [(m.categories)]) : []))
    const subCategories = getLocalizedSubCategories(m, locale)


    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        document: parseStrapiImage(documentUrl),
        raw_category: rawCategories.map(c => withLocalizedCategory(c, locale, type)),
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type,
        uid,
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || [],
        document_type: m?.type?.data?.attributes?.document_type
    }
}

export const adapterSalesSupportMaterial = (material, locale) => adapterMarketingMaterial(
    material, locale, 'sales-support-materials', 'api::sales-support-material.sales-support-material'
)

export const adapterServiceSupport = (m, locale) => {

    const image = (m?.image)
    const document = (m?.document)
    const category = (m?.category)
    const documentUrl = typeof document === 'string' ? document : document?.url
    const videoId = `${m?.video_id || ''}`.trim()

    const rawCategories = Array.isArray(m?.categories?.data)
        ? m.categories.data.map(c => (c))
        : (Array.isArray(m?.categories) ? m.categories.map(c => (c)) : (m?.categories ? (m.categories?.data ? [(m.categories)] : [(m.categories)]) : []))
    const subCategories = getLocalizedSubCategories(m, locale)


    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: image?.url
            ? parseStrapiImage(image.url)
            : (videoId ? `https://fast.wistia.com/embed/medias/${videoId}/swatch` : null),
        description: m?.description,
        document: parseStrapiImage(documentUrl),
        video: isVideoMedia(document) ? {
            ...document,
            url: parseStrapiImage(documentUrl),
        } : null,
        video_id: videoId || null,
        raw_category: rawCategories.map(c => withLocalizedCategory(c, locale, 'service-supports')),
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'service-supports',
        uid: 'api::service-support.service-support',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || [],
        document_type: m?.type?.data?.attributes?.document_type
    }
}

export const adapterMediaTemplate = (m, locale) => {

    const image = (m?.image)
    const document = (m?.document)
    const category = (m?.category)
    const rawCategories = getRawCategories(m)
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        document: parseStrapiImage(document?.url),
        raw_category: rawCategories.length ? rawCategories.map(c => withLocalizedCategory(c, locale, 'media-templates')) : { ...category, type: 'media-templates' },
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'media-templates',
        uid: 'api::media-template.media-template',

        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterVideo = (m, locale) => {

    const image = (m?.image)
    const document = (m?.document)
    const category = (m?.category)
    const rawCategories = getRawCategories(m)
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        document: parseStrapiImage(document?.url),
        raw_category: rawCategories.length ? rawCategories.map(c => withLocalizedCategory(c, locale, 'videos')) : { ...category, type: 'videos' },
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'videos',
        uid: 'api::video.video',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterPhoto = (m, locale) => {

    const image = (m?.image)
    const document = (m?.document)
    const category = (m?.category)
    const rawCategories = getRawCategories(m)
    const subCategories = getLocalizedSubCategories(m, locale)

    return {
        ...m,
        sub_categories: subCategories,
        title: resolveLocalizedTitle(m, locale),
        cover: parseStrapiImage(image?.url),
        document: parseStrapiImage(document?.url),
        raw_category: rawCategories.length ? rawCategories.map(c => withLocalizedCategory(c, locale, 'photos')) : { ...category, type: 'photos' },
        category: (rawCategories[0] && resolveLocalizedTitle(rawCategories[0], locale)) || resolveLocalizedTitle(category, locale) || null,
        author: m?.author,
        date: moment(m?.createdAt)?.format("L"),
        type: 'photos',
        uid: 'api::photo.photo',
        tagType: m?.tag_types?.data?.map(t => t?.attributes?.name) || []
    }
}

export const adapterFavorites = m => {

    return {
        ...m,
        id: m?.content_id,
        refid: m?.id,
        title: m?.title,
        cover: parseStrapiImage(m?.image?.url),
        image: parseStrapiImage(m?.image?.url),
        document: parseStrapiImage(m?.document?.url),
        date: moment(m?.createdAt)?.format("L"),
        type: m?.content_type,
        lesson: m?.lesson,
        lesson_title: m?.lesson_title,
        uid: m?.uid,
        documentId: m?.documentId,
        document_type: m?.document_type,
        isFavorite: true,
        favoriteId: m?.id,
    }
}


export const adapters = {
    courses: adapterCourses,
    'partners-and-staffs': adapterPartnersAndStaff,
    articles: adapterArticles,
    podcasts: adapterPodcasts,
    documents: adapterDocuments,

    'support-materials': adapterSupportMaterial,
    'marketing-materials': adapterMarketingMaterial,
    'sales-support-materials': adapterSalesSupportMaterial,
    'service-supports': adapterServiceSupport,
    'media-templates': adapterMediaTemplate,
    videos: adapterVideo,
    photos: adapterPhoto,
    'product-informations': adapterProductInformations

}
